/** @jsxImportSource theme-ui */

type Props = {
  fill?: string;
};

const IconProjectQCC = ({ fill = "white", ...props }: Props) => (
  <svg viewBox="0 0 450 401" fill="none" {...props}>
    <path
      d="M25.615 66.884c50.163 85.74 181.975 94.634 196.205 228.046.534 5.515 4.803 9.784 10.318 10.673 75.956 11.919 149.955 43.048 214.171 94.634.356.356.889.534 1.423.534s1.067-.178 1.601-.534a2.256 2.256 0 000-3.202c-44.471-46.783-98.903-84.138-159.917-108.686l-18.5-7.471c-9.606-3.914-16.187-13.342-15.832-24.192 1.068-39.846 95.168-31.664 104.774-50.875l1.601-3.38c-19.39-16.543-42.514-28.995-67.774-35.932-.178.889-.889 5.692 4.269 14.053 5.693 9.072-6.048 23.658-23.302 8.004l-1.423-1.245C145.864 70.62 50.519 131.1 0 .178l25.615 66.706z"
      sx={{ fill }}
    />
    <path
      d="M289.061 195.316v31.841c13.697-3.914 29.35-6.404 42.514-9.25v-17.789s-20.813 1.068-33.62-19.922c3.913 6.403-.356 15.12-8.894 15.12zM247.792 308.449c70.441 13.519 138.571 43.937 198.339 91.788-95.701-81.826-154.047-94.278-180.907-94.278-10.317.178-16.187 1.957-17.432 2.49zM.177 0l25.438 66.706c50.163 85.918 181.974 94.812 196.205 228.224-14.587-170.056-89.298-144.619-169.523-222.176C31.663 57.99 14.23 36.466.177 0z"
      sx={{ fill }}
    />
  </svg>
);

export default IconProjectQCC;
